import React from 'react';
import { Unsubscribe } from 'redux';
import actions from '../../../../store/actions';
import store from '../../../../store/store';
import EditableText from '../../../Common/EditableText/EditableText';
import Modal from '../../../Common/Modal/Modal';
import EditSourceModalState from './EditSourceModalState';
import { getDefaultState } from './EditSourceModal.Helpers';
import { validate } from './EditSourceModal.Validation';

interface Props {}

class EditSourceModal extends React.Component<Props, EditSourceModalState> {
    private unsubscribe: Unsubscribe | undefined;

    constructor(props: Props) {
        super(props);

        this.state = getDefaultState();

        this.onOpen = this.onOpen.bind(this);
        this.onSourceChange = this.onSourceChange.bind(this);
        this.onUrlChange = this.onUrlChange.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
        this.close = this.close.bind(this);
    }

    componentDidMount(): void {
        this.unsubscribe = store.subscribe(this.onOpen);
    }

    componentWillUnmount(): void {
        (this.unsubscribe as Unsubscribe)();
    }

    onOpen(): void {
        let state = store.getState();

        if (state.action !== actions.editSourceModal.change) {
            return;
        }

        this.setState(state.editSourceModalChange);
    }

    onSourceChange(value: any) {

        this.setState({ source: value } as EditSourceModalState);
    }

    onUrlChange(value: any) {

        this.setState({ sourceUrl: value } as EditSourceModalState);
    }

    onSaveClick(): void {

        let error = validate(this.state);

        if (error) {
            this.setState({ error: error });
            return;
        }

        store.dispatch({ type: actions.editSourceModal.save, payload: this.state });

        var defaultState = getDefaultState();
        this.setState(defaultState);

        this.close();
    }

    close(): void {
        this.setState({ isOpen: false });
    }

    render(): JSX.Element {

        return (
            <>
                <Modal state={this.state} close={this.close} size="large">

                    <h6 className="mb-3">Source</h6>

                    {
                        <EditableText
                            multiline={false}
                            value={this.state.source}
                            onChange={this.onSourceChange}
                            disabled={false} />
                    }

                    <h6 className="mt-4 mb-3">URL</h6>

                    {
                        <EditableText
                            multiline={false}
                            value={this.state.sourceUrl}
                            onChange={this.onUrlChange}
                            disabled={false} />
                    }

                    <div className="mt-3 mb-3">
                        <button className="btn cb-btn" onClick={this.onSaveClick}>Save</button>
                    </div>

                </Modal>
            </>
        );
    }
}

export default EditSourceModal;